/* eslint-disable react/no-danger */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { replaceIcons } from '../../lib/utils';

const propTypes = {
    body: PropTypes.string,
    tag: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    body: null,
    tag: 'div',
    className: null,
};

const Html = ({ body, tag, className }) => {
    const Container = tag;
    const finalBody = body !== null ? useMemo(() => replaceIcons(body), [body]) : null;
    return <Container className={className} dangerouslySetInnerHTML={{ __html: finalBody }} />;
};

Html.propTypes = propTypes;
Html.defaultProps = defaultProps;

export default Html;
